const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function Svg11(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    height: "100%",
    viewBox: "0 0 1025 1025",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlSpace: "preserve",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      strokeLinejoin: "round",
      strokeMiterlimit: 2
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,-4946,-3318)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "_11",
    transform: "matrix(1,0,0,1,4946.2,3318.14)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 1024,
    height: 1024,
    style: {
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 512,
    cy: 512,
    r: 512,
    style: {
      fill: "rgb(218,176,111)"
    }
  }), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.3631,0,0,1.3631,-185.907,-15.2539)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.971311,0,0,1.05127,-4787.91,-3542.28)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5293,3794.44C5289.12,3791.95 5283.98,3791.95 5280.09,3794.44C5266.36,3803.64 5235.49,3830.26 5235.49,3883.55C5235.49,3910.25 5258.37,3943.35 5286.55,3943.35C5314.72,3943.35 5337.6,3910.25 5337.6,3883.55C5337.6,3830.26 5306.73,3803.64 5293,3794.44Z",
    style: {
      fill: "white"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.971311,0,0,1.05127,-4705.39,-3701.67)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5293,3794.44C5289.12,3791.95 5283.98,3791.95 5280.09,3794.44C5266.36,3803.64 5235.49,3830.26 5235.49,3883.55C5235.49,3910.25 5258.37,3943.35 5286.55,3943.35C5314.72,3943.35 5337.6,3910.25 5337.6,3883.55C5337.6,3830.26 5306.73,3803.64 5293,3794.44Z",
    style: {
      fill: "white"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.971311,0,0,1.05127,-4622.88,-3861.05)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5293,3794.44C5289.12,3791.95 5283.98,3791.95 5280.09,3794.44C5266.36,3803.64 5235.49,3830.26 5235.49,3883.55C5235.49,3910.25 5258.37,3943.35 5286.55,3943.35C5314.72,3943.35 5337.6,3910.25 5337.6,3883.55C5337.6,3830.26 5306.73,3803.64 5293,3794.44Z",
    style: {
      fill: "white"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.971311,0,0,1.05127,-4540.36,-3701.67)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5293,3794.44C5289.12,3791.95 5283.98,3791.95 5280.09,3794.44C5266.36,3803.64 5235.49,3830.26 5235.49,3883.55C5235.49,3910.25 5258.37,3943.35 5286.55,3943.35C5314.72,3943.35 5337.6,3910.25 5337.6,3883.55C5337.6,3830.26 5306.73,3803.64 5293,3794.44Z",
    style: {
      fill: "white"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.971311,0,0,1.05127,-4622.88,-3542.28)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5293,3794.44C5289.12,3791.95 5283.98,3791.95 5280.09,3794.44C5266.36,3803.64 5235.49,3830.26 5235.49,3883.55C5235.49,3910.25 5258.37,3943.35 5286.55,3943.35C5314.72,3943.35 5337.6,3910.25 5337.6,3883.55C5337.6,3830.26 5306.73,3803.64 5293,3794.44Z",
    style: {
      fill: "white"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.971311,0,0,1.05127,-4457.85,-3542.28)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5293,3794.44C5289.12,3791.95 5283.98,3791.95 5280.09,3794.44C5266.36,3803.64 5235.49,3830.26 5235.49,3883.55C5235.49,3910.25 5258.37,3943.35 5286.55,3943.35C5314.72,3943.35 5337.6,3910.25 5337.6,3883.55C5337.6,3830.26 5306.73,3803.64 5293,3794.44Z",
    style: {
      fill: "white"
    }
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg11);
export default __webpack_public_path__ + "static/media/11.789f57c8d104e5be36af795be3f66a6c.svg";
export { ForwardRef as ReactComponent };